module.exports = __webpack_public_path__ + "static/media/Nike_Teamsports11.075ec342.png";